import PropTypes from 'prop-types';
import React from 'react';
import { FontIcon } from 'react-toolbox';
import {
  determineUseActualMOT,
  determineComplete,
  determineMOTTitle,
  determineMOTColorCode,
  determineMOT,
} from '../../../utils/motUtils';
import S from './styles.scss';


const MOT = ({ phase }) => {
  const complete = determineComplete(phase.status, phase.phase_tasks);
  const useActualMOT = determineUseActualMOT(phase.type, phase.appointments, complete);
  const motTitle = determineMOTTitle(phase.type, useActualMOT, complete);
  const motColorCode = determineMOTColorCode(phase, useActualMOT, complete);
  const mot = determineMOT(phase, useActualMOT);

  return (
    <span className={S.mot}>
      <FontIcon value="alarm" />
      {motTitle}: <span className={S[motColorCode]}>{mot}</span>
    </span>
  );
};

MOT.propTypes = {
  phase: PropTypes.object,
};

export default MOT;



// WEBPACK FOOTER //
// ./client/app/shared/components/MOT/index.jsx